import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom-v5-compat";

import { Button } from "./Atoms";
import { useBrand } from "./BrandContext";

// This error page is called when the venue is found and we know the branding information
// This means its the global error catching page for everything except the venue not found / loaded correctly

export const ErrorPage = ({
  errorMessage,
  onAction,
  actionMessage,
}: {
  errorMessage?: string;
  onAction: () => void;
  actionMessage?: string;
}) => {
  const venueBrand = useBrand();

  console.log({ env: process.env.NODE_ENV });
  const { t } = useTranslation("onsite");
  const inDevelopment = process.env.NODE_ENV === "development";
  return (
    <div
      className="max-h-screen overflow-y-hidden bg-venue-secondary"
      style={venueBrand.cssVariables}
    >
      <div className="mx-auto h-screen max-w-screen-sm overflow-y-auto pb-96 opacity-100 sm:max-w-sm">
        <div className="mx-auto my-32 max-w-screen-lg space-y-16 py-16 text-center md:p-32">
          <h3 className="">{errorMessage || t("errors.general")}</h3>
          <Button primary onClick={onAction}>
            {actionMessage || t("errors.reload")}
          </Button>
        </div>
      </div>
    </div>
  );
};

export const VenueErrorPage = ({
  errorMessage,
  resetError,
}: {
  errorMessage?: string;
  resetError: () => void;
}) => {
  const { t } = useTranslation("onsite");
  const navigate = useNavigate();
  const returnHome = () => {
    resetError();
    navigate("/");
  };

  return (
    <ErrorPage
      errorMessage={errorMessage || t("errors.general")}
      onAction={returnHome}
      actionMessage={t("errors.backToHome")}
    />
  );
};

export const PageNotFound = () => {
  const { t } = useTranslation("onsite");
  const navigate = useNavigate();
  const returnHome = () => {
    navigate("/");
  };

  return (
    <ErrorPage
      errorMessage={t("errors.pageNotFound")}
      onAction={returnHome}
      actionMessage={t("errors.backToHome")}
    />
  );
};
// This is the true global error page, but in reality only handles incorrectly loaded venues.
// everything else is handled by the VenueErrorPage
export const GlobalErrorPage = ({ errorMessage }: { errorMessage: string }) => {
  return (
    <div className="bg-venue-background max-h-screen overflow-y-hidden">
      <div className="mx-auto h-screen max-w-screen-sm overflow-y-auto border-b-2 bg-white pb-96 opacity-100 sm:max-w-sm">
        <div className="mx-auto my-32 flex max-w-screen-lg flex-wrap content-center items-center justify-center space-y-16 py-16 sm:space-x-32 md:space-x-64 md:p-32">
          <h3 className="">{errorMessage}</h3>
        </div>
      </div>
    </div>
  );
};
